
import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';

import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { WebHttpClientWithErrorToast, WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { IExtractTaskInfo } from '../models/IExtractTaskInfo';
import { DeleteExtractTasksRequest } from '../serverApi/requests/DeleteExtractTasksRequest';
import { GetExtractTasksRequest } from '../serverApi/requests/GetExtractTasksRequest';
import { ResumeExtractTasksRequest } from '../serverApi/requests/ResumeExtractTasksRequest';
import { RunExtractTasksRequest } from '../serverApi/requests/RunExtractTasksRequest';
import { SetExtractTasksPriorityRequest } from '../serverApi/requests/SetExtractTasksPriorityRequest';
import { SetExtractTasksScheduleRequest } from '../serverApi/requests/SetExtractTasksScheduleRequest';

export class ExtractTasksResource {

  private fetcher = new WebClientListResourceFetcher(GetExtractTasksRequest,ServerApiMapper.extractTasks);

  public MAX_PRIORITY = 100;
  public MIN_PRIORITY = 1;

  public del(ids: string[]): Promise<IResult> {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteExtractTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public all(): ResourceQuery<IExtractTaskInfo> {
    return new ResourceQuery(this.fetcher);
  }

  public run(ids: string[]): Promise<IResult> {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new RunExtractTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public resume(ids: string[]): Promise<IResult> {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new ResumeExtractTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public setPriority(ids: string[], priority: number): Promise<IResult> {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetExtractTasksPriorityRequest(idsBlock, priority)),
      ResultHelper.combineResults);
  }

  public setSchedule(ids: string[], scheduleId: string) {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetExtractTasksScheduleRequest(idsBlock, scheduleId)),
      ResultHelper.combineResults);
  }

  public getErrorNotifyingServer(): WebHttpClientWithErrorToast {
    return WebHttpClientWithErrorToastInstance;
  }

}
  export const ExtractTasks = new ExtractTasksResource();
